export class CertificatesDto {
    certificateId?: number;
    certificateName: string;
    remarks: string;
    isActive: boolean;
    constructor(certificateId:number,certificateName:string,remarks: string,isActive:boolean){
        this.certificateId = certificateId;
        this.certificateName = certificateName;
        this.remarks = remarks;
        this.isActive = isActive;
    }
}

export const CertificatesDtoDefault : CertificatesDto = {
    certificateId: 0,
    certificateName: "",
    remarks:"",
    isActive:true,
};

